import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/broker",
    name: "Broker Portal",
    component: () => import("./brokerDashboard.vue"),
  },
  {
    path: "/broker-usage/:ldcAccountId",
    name: "Broker Account Summary",
    component: () => import("./brokerAccountSummary.vue"),
    props: true,
  },
] satisfies RouteRecordRaw[];
